// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'docService' implicitly has an 'any' typ... Remove this comment to see the full error message
const MoreDetails = (docService, translationService) => ({
   replace: true,
   templateUrl: '/assets/moreDetails.html',

   scope: {
      document: '=',
      fieldSearch: '&'
   },

   link(scope: any) {
      scope.i18n = translationService
      // load data into directive when document value in the directive scope changes
      return scope.$watch('document', function(newVal: any, oldVal: any, scope: any) {
         if (!newVal || _.isEmpty(newVal)) { return }
         return scope.computedVals = docService.getComputedValues(newVal)
      })
   }
})

const DetailRow = (translationService: any) => ({
   templateUrl: '/assets/detailRow.html',
   transclude: true,

   scope: {
      rowLabel: '@',
      rowValue: '=',
      displayValue: '@',
      delimiter: '@',
      transclude: '=',     // omit the attribute if NOT needed
      fieldSearch: '&',
      labelClass: '@',
      valueClass: '@'
   },

   link(s: any) {
      return s.i18n = translationService
   }
})

const SourceLinks = (translationService: any) => ({
   replace: true,
   templateUrl: '/assets/sourceLinks.html',

   scope: {
      databases: '='
   },

   link(s: any) {
      return s.i18n = translationService
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'configs' implicitly has an 'any' type.
const DoiLink = (configs, utils) => ({
   replace: true,
   template: '<a ng-href="{{ link }}" target="_blank" ng-bind="doi"></a>',

   scope: {
      doi: '@',
      openAccess: '<'
   },

   link(s: any) { 
      s.$watch( 'doi', function() {
         const configData = configs.data
         const doiUrl = `https://dx.doi.org/${s.doi}`
         s.link = configData.results.proxyDoiLinks && !s.openAccess ? utils.proxify(doiUrl, configData.vpnBanner.proxy) : doiUrl
     } );
   }
})

const EricLink = () => ({
   replace: true,
   template: '<a ng-href="//eric.ed.gov/ERICWebPortal/detail?accno={{ ::eric }}" target="_blank" ng-bind="eric"></a>',

   scope: {
      eric: '@'
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'docQueryService' implicitly has an 'any... Remove this comment to see the full error message
const BookReviews = (docQueryService, $broadcastTypes, translationService) => ({
   replace: true,
   templateUrl: '/assets/bookReviews.html',

   scope: {
      reviewDoc: '='
   },

   link(scope: any) {
      scope.searchReviews = docQueryService.searchReviews
      scope.i18n = translationService

      // pull in functions from parent scope
      scope.fieldSearch = scope.$parent.fieldSearch
      scope.openClickTrackLink = scope.$parent.openClickTrackLink

      // turn off loading indicator when an API response (success/failure) is received
      const turnOffSpinner = function(evt: any, msg: any) {
         if (!scope.reviewsPossible || !msg.types.includes($broadcastTypes.other)) { return }
         scope.loaded = true
         return scope.hideSection || (scope.hideSection = evt.name === 'apiError')
      }
      scope.$on('apiSuccess', turnOffSpinner)
      scope.$on('apiError', turnOffSpinner)

      const newBookReview = function() {
         scope.reviewsPossible = ["Book", "eBook"].includes(scope.reviewDoc.content_type)
         if (scope.reviewsPossible) {
            return scope.loaded = false
         }
      }

      const updateBookReview = function() {
         scope.reviewsPossible = ["Book", "eBook"].includes(scope.reviewDoc.content_type)
         if (scope.reviewsPossible) {
            scope.reviews = docQueryService.data.reviews[scope.reviewDoc.id]
            scope.loaded = true
            return scope.hideSection = !scope.reviews || !scope.reviews.length
         }
      }

      docQueryService.on("new", "bookReviews", newBookReview)
      docQueryService.on("update", "bookReviews", updateBookReview)

      return scope.$on('$destroy', () => {
         docQueryService.off('new', "bookReviews")
         return docQueryService.off('update', "bookReviews")
      })
   }
})

const LibraryThing = (translationService: any) => ({
   replace: true,
   templateUrl: '/assets/libraryThing.html',

   scope: {
      isbn: '@'
   },

   link(s: any) {
      s.i18n = translationService
      // load data into directive when isbn value in the directive scope changes
      return s.$watch('isbn', function(newVal: any) {
         if (newVal === "") { return }
         const isbn = $.trim(newVal)

         const ltCallback = function(booksInfo: any) {
            if (booksInfo == null) { booksInfo = {} }
            return s.info = booksInfo[isbn] || {}
         }

         const options = {
            url: `//www.librarything.com/api/json/workinfo.js?ids=${isbn}`,
            cache: true,
            dataType: 'jsonp',
            success: ltCallback,
            error: ltCallback
         }

         // get cross-domain properties using jsonp datatype
         return $.ajax(options)
      })
   }
})

const ContentType = (translationService: any) => ({
   replace: true,
   templateUrl: '/assets/contentType.html',

   scope: {
      isLabel: '@',
      contentTypes: '='
   },

   link(s: any) {
      return s.i18n = translationService
   }
})

const ClickTrackLinkForm = (config: any, $window: any) => ({
   replace: true,
   templateUrl: '/assets/clickTrackLinkForm.html',

   link(s: any, el: any, attrs: any) {
      // non-safari browsers in iOS do not support target=_blank properly, and don't POST link-form data. This causes error 500.
      // because sniffing these browsers is tricky/impossible, just do this for all iOS devices... SMN-4566 et al.
      // there is also a setting which can change this behavior for all links
      if (!$window.bowser.ios && !config.data.metrics.clicktrackFormTargetsSelf) {
         el.attr('target', '_blank')
      }

      if(config.data.authentication.referUrlAuth) {
         el.attr('rel', '') // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/noreferrer set automatically in POST was removing referer
      }

      return s.$watch('clickTrackLinkForm.linkData', function() {
         const formData = s.clickTrackLinkForm
         if ((formData.action !== "") && (formData.linkData !== "")) {
            el.attr('action', s.$eval(attrs['summonFormAction']))
            el.submit()
            // reset form values
            formData.action = '/2.0.0/link'
            return formData.linkData = ''
         }
      })
   }
})

angular.module('summonApp.directives')
   .directive('moreDetails', ['documentService', 'translationService', MoreDetails])
   .directive('detailRow', ['translationService', DetailRow])
   .directive('sourceLinks', ['translationService', SourceLinks])
   .directive('doiLink', ['configService', 'utilitiesService', DoiLink])
   .directive('ericLink', EricLink)
   .directive('bookReviews', ['documentQueryService', '$broadcastTypes', 'translationService', BookReviews])
   .directive('libraryThing', ['translationService', LibraryThing])
   .directive('contentType', ['translationService', ContentType])
   .directive('clickTrackLinkForm', ['configService', '$window', ClickTrackLinkForm])
  

